import React from "react";
import {GameLoadingIndicatorBaseModel} from "./game-loading-indicator-base.model";
import {
    WebAppGameLoadingIndicatorComponent
} from "../../../components/game-window/loading-indicators/web-app/web-app-game-loading-indicator.component";

export class WebAppGameLoadingIndicatorModel extends GameLoadingIndicatorBaseModel {
    render(): React.ReactElement {
        return (
            <WebAppGameLoadingIndicatorComponent/>
        );
    }
}